import randomColor from 'randomcolor'

export function generateRandomColor(opts) {
  return randomColor(opts)
}

export function generateRandomColorForUser(userId) {
  return generateRandomColor({
    seed: userId,
    luminosity: 'dark',
  })
}

export function getFontColor(hex) {
  const [r, g, b] = hexToRgb(hex)

  if (r * 0.299 + g * 0.587 + b * 0.114 > 186) {
    return '#000000'
  }
  return '#FFFFFF'
}

export function hexToRgb(hex) {
  // Ensure hex is in 'FFFFFF' format
  hex = hex
    .replace('#', '')
    .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => r + r + g + g + b + b)

  return hex.match(/.{2}/g).map((x) => parseInt(x, 16))
}

export function isLightColor(hex) {
  const [r, g, b] = hexToRgb(hex)

  if (r * 0.299 + g * 0.587 + b * 0.114 > 186) {
    return true
  }
  return false
}

// The Aryeo purple every company starts with before setting its own brand color.
export const DEFAULT_BRAND_COLOR = '#4f46e5'

// Pass treatDefaultAsCustom to render the default brand color as if it were a custom one.
export function resolveBrandingColorTokenWithCustom(
  token,
  customColor,
  brandingPrimaryColor,
  treatDefaultAsCustom = false
) {
  if (token === 'black') {
    return '#111116'
  }

  if (token === 'white') {
    return '#FFFFFF'
  }

  if (token === 'custom') {
    return customColor || '#FFFFFF'
  }

  if (!treatDefaultAsCustom && brandingPrimaryColor?.toLowerCase() === DEFAULT_BRAND_COLOR) {
    return '#FFFFFF'
  }

  return brandingPrimaryColor
}
